export default __webpack_public_path__ + "static/media/Changed_logo.7e225227.png";